import { LogLevel, type Configuration, type RedirectRequest } from '@azure/msal-browser';

const runtimeConfig = window.__ALGOBRIDGE_CONFIG__;

function readEnvironmentValue(value: string | undefined): string {
  return value ?? '';
}

const tenantId = readEnvironmentValue(runtimeConfig?.entraTenantId ?? import.meta.env.VITE_ENTRA_TENANT_ID);
const clientId = readEnvironmentValue(runtimeConfig?.entraClientId ?? import.meta.env.VITE_ENTRA_CLIENT_ID);
const apiScope = readEnvironmentValue(runtimeConfig?.apiScope ?? import.meta.env.VITE_API_SCOPE);

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    // The app is served from the API's own origin in production and from the dev server locally,
    // so the redirect URI is whatever origin the app is running on.
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Error,
      loggerCallback: (_level, message, containsPii) => {
        if (!containsPii && import.meta.env.DEV) console.warn(`[msal] ${message}`);
      },
    },
  },
};

/** The API's delegated scope — every call this app makes needs a token carrying it. */
export const apiTokenRequest: RedirectRequest = {
  scopes: [apiScope],
};

export const loginRequest: RedirectRequest = {
  scopes: [apiScope],
};

/** True when every required Entra value is present and no placeholder identifier remains. */
export const isEntraConfigured =
  clientId.length > 0 &&
  tenantId.length > 0 &&
  apiScope.length > 0 &&
  clientId !== '00000000-0000-0000-0000-000000000000' &&
  tenantId !== '00000000-0000-0000-0000-000000000000';
